import React from "react";
import './style.css';
import Video from "../../asset/vid/save-featured-video-1.webm";

const Section1 = () => {
  const [fS, setFS] = React.useState(3);
  const [lH, setLH] = React.useState(1.5);
  React.useEffect(() => {
    window.innerWidth < 768 ? setFS(2) : setFS(3);
    window.innerWidth < 768 ? setLH(1.2) : setLH(1.2);
  }, [fS, lH]);

  return (
    <>
      <div className="section-1 card shadow mx-lg-0 mx-2">
        <div className="px-4 px-lg-3 py-4 py-lg-5 
          d-flex flex-column flex-lg-row align-items-center text-center text-lg-start">
          <div className="col-12 col-lg-6 ps-0 ps-lg-4">
            <div className="fw-medium card-title"
              style={{fontSize: `${fS}rem`, lineHeight: `${lH}`}}>
              Secure AI based Vulnerability Assessment Tool for Enterprises
            </div>
            <div className="py-3"></div>
            <div className="fs-6 fw-light pe-0 pe-lg-4 card-text">SAVE empowers businesses to confidently navigate the complex cyber landscape. By unifying people, processes, and technology, organizations can quickly assess their security posture, identify vulnerabilities, and make informed decisions to mitigate risks.</div>
          </div>
          <div className="col-12 col-lg-6 pt-4 pt-lg-0 px-0 px-lg-3">
            <div className="ratio ratio-16x9">
              <video
                className="w-100" 
                src={Video} 
                autoPlay 
                muted 
                loop 
                style={{
                  border: `solid 1px rgb(82, 84, 109)`
                }}/> 
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section1;

